import dimensionEnum from "@/model/dimensionEnum";

export const staffHistoryHelper = {

  dimensions: [
    dimensionEnum.SITE,
    dimensionEnum.STAFFGAMEHISTORY_CARDNUMBER,
    dimensionEnum.STAFFGAMEHISTORY_EVENTDATE,
    dimensionEnum.EMPLOYEE_FIRSTNAME,
    dimensionEnum.EMPLOYEE_LASTNAME,
    dimensionEnum.GAME_NAME,
    dimensionEnum.SMARTTOUCH_NUMBER,
  ],
  measures: [],

  getQuery(filters) {
    const query = {
        measures: this.measures,
        dimensions: this.dimensions,
        filters: filters,
    };
    return query;
  },
};